import React, { useState, useRef } from 'react';

import manHoldingPhone from '../../assets/about_man_holding_phone.png';
import farm_operation from '../../assets/farm-operation.jpg';
import expertise from '../../assets/about/expert.png';

import about_video from '../../assets/Video/website.mp4';
import Slider from '@/Components/Slider';
import Link from 'next/link';

import Image from 'next/image';
import { motion, AnimatePresence } from 'framer-motion';
import Head from 'next/head';
import ContentText from '@/Components/ContentText';
import ContentTitle from '@/Components/ContentTitle';
import { Button } from '@/Components/Button';
import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';
import { VideosArray } from '@/Components/Videos';

export default function AboutUS() {
  const [FarmImage, setFarmImage] = useState(farm_operation);
  const scrollRef = useRef(null);

  return (
    <div className="">
      <Head>
        <title>About Fyllo company | What is Fyllo? | How Fyllo works?</title>
        <meta name="title" content="About Fyllo company | What is Fyllo? | How Fyllo works?" />
        <meta
          name="description"
          content="Fyllo helps farmers take precise decisions and increase farm productivity. We install devices on farms that provide farmers with access to real-time farm data, insights, and analytics through our mobile app"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="keywords" content="about fyllo, fyllo, fyllo company, IoT company, agritech company" />
        <meta name="robots" content="index, follow" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="30 days" />
        <meta name="author" content="Fyllo" />

        <meta name="title" content="About Fyllo company | What is Fyllo? | How Fyllo works?" />
        <meta
          name="description"
          content="Fyllo helps farmers take precise decisions and increase farm productivity. We install devices on farms that provide farmers with access to real-time farm data, insights, and analytics through our mobile app."
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fyllo.io/" />
        <meta property="og:title" content="About Fyllo company | What is Fyllo? | How Fyllo works?" />
        <meta
          property="og:description"
          content="Fyllo helps farmers take precise decisions and increase farm productivity. We install devices on farms that provide farmers with access to real-time farm data, insights, and analytics through our mobile app."
        />
        <meta property="og:image" content="/fyllo.png" />

        <link rel="manifest" href="/site.webmanifest" />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@site_account" />
        <meta name="twitter:creator" content="@fylloTech" />
        <meta name="twitter:url" content="https://twitter.com/fyllotech?lang=en" />
        <meta property="twitter:title" content="About Fyllo company | What is Fyllo? | How Fyllo works?" />
        <meta
          property="twitter:description"
          content="Fyllo helps farmers take precise decisions and increase farm productivity. We install devices on farms that provide farmers with access to real-time farm data, insights, and analytics through our mobile app."
        />
        <meta property="twitter:image" content="/fyllo.png"></meta>
      </Head>
      <main className=" bg-white relative -mt-12 " ref={scrollRef}>
        <div className="gap-8 flex flex-col">
          <div className="absolute  grid place-items-start w-screen py-8 px-4 mx-auto  text-left lg:py-16 lg:px-6 ">
            <div className="mx-auto  md:pt-8 lg:pt-24 xl:pt-36 w-full max-w-screen-lg">
              {/* <h2 className="text-white mb-4 text-2xl font-bold tracking-tight leading-none md:text-5xl xl:text-4xl  text-center">
                About us
              </h2> */}
              <MainHeading text="About Us" styles="text-white text-lg" />
              <SubHeading styles="text-white text-[7px] sm:text-xs md:text-sm">
                Greek word Fyllo (φύλλο) means leaf. It signifies agriculture and prosperity. Fyllo was started with an
                aim to make decision making easy and accurate in Agriculture. All our solutions intend to remove guess
                work in farming activities and bring certainity in quality and quantity of produce. We started Fyllo in
                2019 with a handful of farmers and today thousands of farmers use Fyllo to make decisions at their farm
                throughout the crop season.
                <br /> <br />
                We intend to make each decision in crop produce cycle to be data driven and precise. Fyllo has over 100
                agronomy models to help producers grow over 20 crops.
              </SubHeading>
              {/* <p className="text-center text-[6px] font-light text-gray-300  md:text-sm lg:text-lg xl:text-xl ">
               
              </p> */}
              <div className="flex items-center justify-center">
                <Link
                  className="relative border-2 px-6 py-1 rounded-full z-10 cursor text-[10px] lg:text-2xl transition-all "
                  href={`/gallery`}
                >
                  <p className={'text-white'}>Gallery</p>
                </Link>
              </div>
            </div>
          </div>
          <video className="" autoPlay loop muted playsInline>
            <source autoPlay src={about_video} />
          </video>
        </div>
        <div className="grid md:grid-cols-2 place-items-center p-10 gap-8">
          <div>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-5 md:p-5">
              <div className="grid grid-cols-1 gap-8 md:p-5 lg:p-2">
                <ContentTitle
                  text="Expert Decision-Making for Optimal Farm Operations with Precision Farming"
                  styles="text-2xl md:text-3xl lg:text-4xl text-center md:text-left"
                />
              </div>
              <button
                className={
                  (FarmImage === farm_operation
                    ? ' border-fyllo-700 border-t-green-700 md:border-t-white  border-b-fyllo-800 md:border-l-green-700   '
                    : ' border-white ') +
                  '  border-white shadow-sm md:shadow hover:shadow md:hover:shadow-lg  border-b-8 md:border-b-0  md:border-l-8 p-4 flex flex-col rounded md:rounded-2xl'
                }
                onClick={() => {
                  setFarmImage(farm_operation);
                }}
              >
                <h3 className="text-xl font-extrabold text-fyllo-800 pb-2">Farm Operation</h3>
                <p className="text-start text-gray-600">
                  We provide professional agricultural services to corporate farming, exporters, and agri input
                  companies. Our expertise helps clients reduce costs, increase efficiency, and maximize profitability.
                  We analyze operations, offer guidance on trade regulations, and provide marketing and branding
                  services. Our goal is to ensure long-term success in the agricultural industry.
                </p>
              </button>

              <button
                className={
                  (FarmImage === manHoldingPhone
                    ? ' border-fyllo-700 border-t-green-700 md:border-t-white  border-b-fyllo-800 md:border-l-green-700   '
                    : ' border-white ') +
                  '  border-white shadow-sm md:shadow hover:shadow md:hover:shadow-lg  border-b-8 md:border-b-0  md:border-l-8 p-4 flex flex-col rounded md:rounded-2xl'
                }
                onClick={() => {
                  setFarmImage(manHoldingPhone);
                }}
              >
                <h3 className="text-start text-xl font-extrabold text-fyllo-800 pb-2">
                  Precision Farming and Advanced Analytics
                </h3>
                <p className="text-start text-gray-600">
                  Our dashboard is designed to simplify the decision-making process for farmers by providing them with a
                  wealth of information at their fingertips. From weather forecasts to soil moisture levels, our
                  platform empowers farmers to make data-driven decisions that optimize yield and profitability
                </p>
              </button>

              <button
                className={
                  (FarmImage === expertise
                    ? ' border-fyllo-700 border-t-green-700 md:border-t-white border-b-fyllo-800 md:border-l-green-700   '
                    : ' border-white ') +
                  '  border-white shadow-sm md:shadow hover:shadow md:hover:shadow-lg  border-b-8 md:border-b-0  md:border-l-8 p-4 flex flex-col rounded-lg md:rounded-2xl'
                }
                onClick={() => {
                  setFarmImage(expertise);
                }}
              >
                <h3 className="text-start text-xl font-extrabold text-fyllo-800 pb-2">Expertise</h3>
                <p className="text-start text-gray-600">
                  With deep knowledge in Agronomy, Climate Science, and Technology Development, our team is uniquely
                  positioned to develop state-of-the-art solutions for the farming industry. Our hardware and software
                  products enable farmers to make informed decisions that maximize yields, minimize risks, and enhance
                  environmental sustainability.
                </p>
              </button>
            </div>
            <div className="grid grid-cols-3 pt-8 md:p-8 md:gap-1 place-items-center">
              <div className="text-xs md:text-base border-b-2 border-white hover:border-green-500 transition-all ease-in-out delay-150">
                <Link href={'/about/data-collection'}>Data Collection</Link>
              </div>
              <div className="text-xs md:text-base border-b-2 border-white hover:border-green-500 transition-all ease-in-out delay-150">
                <Link href="/crop">Agronomy Model</Link>
              </div>
              <div className="text-xs md:text-base border-b-2 border-white hover:border-green-500 transition-all ease-in-out delay-150">
                <Link href={'/about/weather-model'}>Weather Model</Link>
              </div>
            </div>
          </div>

          <motion.div
            initial={{ scale: 1.3, opacity: 0 }}
            whileInView={{
              scale: 1,
              opacity: 1,
              transition: {
                delay: 1,
                duration: 0.6,
              },
            }}
            transition={{
              type: 'spring',
              stiffness: 260,
              damping: 20,
            }}
            viewport={{ once: true }}
            className="w-full  relative"
          >
            <Image
              className={'z-10 aspect-square object-cover rounded-xl shadow-xl transition-all '}
              src={FarmImage}
              alt={'expertise'}
              srcSet=""
              sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
            />
          </motion.div>
        </div>

        <div className="w-full flex justify-center mt-12 -mb-8">
          <ContentTitle text="A sneak peak of our journey till now..." styles='text-2xl md:text-3xl lg:text-4xl' />
        </div>


        <Slider sliderName={'default'} slidesPerView={1} imgArray={VideosArray} isPlay={false} />
        <div className="grid place-items-center px-2 pt-5">
          <ContentText
            styles=" mb-1 text-center"
            text={'If you would like to be part of the team, check out our careers page.'}
          />

          <Link href={'/contact#contact_form'} className='mb-10'>
            <Button size="lg">Join Us</Button>
          </Link>
        </div>
      </main>
    </div>
  );
}
